(() => {
  if (customElements.get('dviny-uv-pricing')) return;
  const tiers = [[380000, 5], [100000, 6], [25000, 7], [15000, 8], [9900, 9], [4900, 10]];
  function calculate(baseUnit, quantity, cartSubtotal, currency) {
    const subtotal = baseUnit * quantity + cartSubtotal;
    const rate = currency === 'USD' ? (tiers.find(([threshold]) => subtotal > threshold)?.[1] ?? 22) : 22;
    return { rate, unit: baseUnit * rate / 22, total: Math.round(baseUnit * quantity * rate / 22), original: baseUnit * quantity };
  }
  class DvinyUVPricing extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('MainProduct-' + this.dataset.section);
      if (!this.root) return;
      this.variants = JSON.parse(this.querySelector('[data-uv-variants]').textContent);
      this.cart = JSON.parse(this.querySelector('[data-uv-cart]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-uv-labels]').textContent);
      this.onInteraction = () => { queueMicrotask(() => this.update()); };
      this.onFocus = () => this.refreshCart();
      this.root.addEventListener('input', this.onInteraction);
      this.root.addEventListener('change', this.onInteraction);
      this.root.addEventListener('click', this.onInteraction);
      window.addEventListener('focus', this.onFocus);
      this.onSubmit = () => { clearTimeout(this.refreshTimer); this.refreshTimer = setTimeout(() => this.refreshCart(), 1200); };
      this.root.addEventListener('submit', this.onSubmit);
      this.update();
      this.refreshCart();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('input', this.onInteraction);
      this.root?.removeEventListener('change', this.onInteraction);
      this.root?.removeEventListener('click', this.onInteraction);
      this.root?.removeEventListener('submit', this.onSubmit);
      window.removeEventListener('focus', this.onFocus);
      clearTimeout(this.refreshTimer);
    }
    selectedVariant() {
      const picker = this.root.querySelector('variant-selects, variant-radios');
      const options = picker ? Array.from(picker.querySelectorAll('select, input[type="radio"]:checked')).map(input => input.value) : [];
      const match = this.variants.find(variant => options.length && variant.options.every((option, i) => option === options[i]));
      if (match) return match;
      const input = this.root.querySelector('form[action*="/cart/add"] input[name="id"]');
      return this.variants.find(variant => String(variant.id) === input?.value) || this.variants[0];
    }
    update() {
      if (!this.isConnected) return;
      const variant = this.selectedVariant();
      if (!variant) return;
      const raw = Number(this.root.querySelector('input[name="quantity"]')?.value || 1);
      if (!Number.isSafeInteger(raw) || raw < 1) return;
      const currency = this.cart?.currency || this.dataset.currency || 'USD';
      const formatter = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency });
      const cartSubtotal = (this.cart?.items || []).filter(item => String(item.product_id) === this.dataset.product).reduce((sum, item) => sum + item.original_line_price, 0);
      const result = calculate(variant.price, raw, cartSubtotal, currency);
      this.querySelector('[data-uv-unit]').textContent = formatter.format(result.unit / 100);
      this.querySelector('[data-uv-total]').textContent = formatter.format(result.total / 100);
      const original = this.querySelector('[data-uv-original]');
      original.hidden = result.rate === 22;
      original.textContent = formatter.format(result.original / 100);
      this.querySelector('[data-uv-rate]').textContent = currency !== 'USD' ? this.labels.currency : result.rate === 22 ? this.labels.regular : this.labels.rate.replace('[rate]', formatter.format(result.rate / 100));
    }
    async refreshCart() {
      try {
        const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (!Array.isArray(cart.items)) return;
        this.cart = cart;
        this.update();
      } catch {}
    }
  }
  customElements.define('dviny-uv-pricing', DvinyUVPricing);
})();
